import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { UploadArtifact } from '../UploadArtifact/UploadArtifact';
import {
  IUploadArtifactPanelClassNames,
  IUploadArtifactPanelStyles,
  uploadArtifactPanelStylesDefault,
} from './UploadArtifactPanel.styles';

const getBreadcrumbItems = (featureSetName = ''): IBreadcrumbItem[] => {
  return [
    { text: featureSetName, key: featureSetName },
    {
      text: ContentsTitle.uploadArtifact,
      key: ContentsTitle.uploadArtifact,
      isCurrentItem: true,
    },
  ];
};

interface IUploadArtifactPanelProps {
  featureSetId?: string;
  featureSetName?: string;
  featureSetMajorVersion?: string;
  show: boolean;
  onDismiss: (ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined, uploaded?: boolean) => void;
}

export const UploadArtifactPanel = ({
  featureSetId,
  featureSetName,
  featureSetMajorVersion,
  show,
  onDismiss,
}: IUploadArtifactPanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss,
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.uploadArtifact,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(featureSetName),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IUploadArtifactPanelStyles, IUploadArtifactPanelClassNames>(
    'UploadArtifactPanel',
    uploadArtifactPanelStylesDefault
  );
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <UploadArtifact
          featureSetId={featureSetId}
          featureSetMajorVersion={featureSetMajorVersion}
          onSave={() => onDismiss(undefined, true)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
